var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpinnerIcon = function SvgSpinnerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 5.625C31.0355 5.625 31.875 6.46447 31.875 7.5V15C31.875 16.0355 31.0355 16.875 30 16.875C28.9645 16.875 28.125 16.0355 28.125 15V7.5C28.125 6.46447 28.9645 5.625 30 5.625Z",
    fill: "#646EC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2399 12.7601C47.9721 13.4923 47.9721 14.6795 47.2399 15.4118L41.943 20.7086C41.2108 21.4409 40.0236 21.4409 39.2914 20.7086C38.5591 19.9764 38.5591 18.7892 39.2914 18.057L44.5882 12.7601C45.3205 12.0279 46.5077 12.0279 47.2399 12.7601Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.125 30C43.125 28.9645 43.9645 28.125 45 28.125H52.5C53.5355 28.125 54.375 28.9645 54.375 30C54.375 31.0355 53.5355 31.875 52.5 31.875H45C43.9645 31.875 43.125 31.0355 43.125 30Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2914 39.2914C40.0236 38.5591 41.2108 38.5591 41.943 39.2914L47.2399 44.5882C47.9721 45.3205 47.9721 46.5077 47.2399 47.2399C46.5077 47.9721 45.3205 47.9721 44.5882 47.2399L39.2914 41.943C38.5591 41.2108 38.5591 40.0236 39.2914 39.2914Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 43.125C31.0355 43.125 31.875 43.9645 31.875 45V52.5C31.875 53.5355 31.0355 54.375 30 54.375C28.9645 54.375 28.125 53.5355 28.125 52.5V45C28.125 43.9645 28.9645 43.125 30 43.125Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7086 39.2914C21.4409 40.0236 21.4409 41.2108 20.7086 41.943L15.4118 47.2399C14.6795 47.9721 13.4923 47.9721 12.7601 47.2399C12.0279 46.5077 12.0279 45.3205 12.7601 44.5882L18.057 39.2914C18.7892 38.5591 19.9764 38.5591 20.7086 39.2914Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 30C5.625 28.9645 6.46447 28.125 7.5 28.125H15C16.0355 28.125 16.875 28.9645 16.875 30C16.875 31.0355 16.0355 31.875 15 31.875H7.5C6.46447 31.875 5.625 31.0355 5.625 30Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7601 12.7601C13.4923 12.0279 14.6795 12.0279 15.4118 12.7601L20.7086 18.057C21.4409 18.7892 21.4409 19.9764 20.7086 20.7086C19.9764 21.4409 18.7892 21.4409 18.057 20.7086L12.7601 15.4118C12.0279 14.6795 12.0279 13.4923 12.7601 12.7601Z",
    fill: "black"
  })));
};
export default SvgSpinnerIcon;